var _line, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPSignalChiller = function SvgPSignalChiller(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 242.1,
    y1: 237.2,
    x2: 242.1,
    y2: 377,
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "342.1,46.1 342.1,55.1 304,55.1 304,237.1 304,237.2 174.1,237.2 174.1,377",
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgPSignalChiller;